/**
 * Create a proxy throwing destroyed errors upon access.
 *
 * @param type The type to display upon error
 * @returns The proxy instance
 */
export function createDestroyedProxy(type: string) {
    return new Proxy(
        {},
        {
            get(_, param: string) {
                if (param === 'isDestroyed') return true;
                throw new Error(`Cannot read '${param}' of destroyed ${type}`);
            },
            set(_, param: string) {
                throw new Error(`Cannot write '${param}' of destroyed ${type}`);
            },
        }
    );
}
